import type { Company } from 'models/company'

export interface IssuerAttribution {
  issuerName: string
  issuerDetails: string
}

const FALLBACK_NAME = '[ISSUER LEGAL NAME]'

/** Precedence and fallback copy for the issuer attribution disclaimer. */
export const buildIssuerAttribution = (issuer: Company | null | undefined): IssuerAttribution => {
  const issuerName = issuer?.legalName || issuer?.title || issuer?.name || FALLBACK_NAME
  const parts = [issuer?.legalForm, issuer?.legalRegistrationAddress, issuer?.legalRegistrationNumber]
    .map((part) => (typeof part === 'string' ? part.trim() : ''))
    .filter(Boolean)

  return { issuerName, issuerDetails: parts.length ? `, ${parts.join(', ')}` : '' }
}
